import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import timeSeriesReadAction from './timeSeriesRead.action.json'

const timeSeriesReadDefinition = defineReadAutoAction(timeSeriesReadAction, 'timeSeries')

export default timeSeriesReadDefinition
